module.exports = __webpack_public_path__ + "img/explain_02.5382fcd3.jpg";